import { render, staticRenderFns } from "./DepositHoldBlock.vue?vue&type=template&id=16ea4efc"
import script from "./DepositHoldBlock.vue?vue&type=script&lang=js"
export * from "./DepositHoldBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports